document.addEventListener("DOMContentLoaded", function () {
  var root = document.querySelector(".phy-blog-category-links");

  if (!root) {
    return;
  }

  var thumb = root.querySelector(".phy-blog-category-links__thumb");
  var prevBtn = root.querySelector(".phy-blog-category-links__arrow--prev");
  var nextBtn = root.querySelector(".phy-blog-category-links__arrow--next");
  var slidesToShow = 2;
  var total = root.querySelectorAll(".phy-blog-category-links__item").length;
  // Number of stops with slidesToScroll: 1 (non-infinite).
  var pages = Math.max(1, total - slidesToShow + 1);

  // Size the pill to one "page" wide; JS drives width since it depends on count.
  if (thumb) {
    thumb.style.width = 100 / pages + "%";
  }

  function moveThumb(index) {
    if (!thumb) {
      return;
    }
    var clamped = Math.min(Math.max(index, 0), pages - 1);
    thumb.style.transform = "translateX(" + clamped * 100 + "%)";
  }

  // Grey out + disable an arrow when there's nowhere to scroll in that direction
  // (Slick runs non-infinite, so prev is dead at page 0 and next at the last page).
  function updateArrows(index) {
    if (prevBtn) {
      prevBtn.disabled = index <= 0;
    }
    if (nextBtn) {
      nextBtn.disabled = index >= pages - 1;
    }
  }

  // On the last page there's no next card, so flip the peek strip to the left to
  // tease the previous card instead of leaving an empty gap on the right.
  function updatePeekSide(index) {
    var atEnd = pages > 1 && index >= pages - 1;
    $list.toggleClass("phy-blog-category-links__list--peek-start", atEnd);
  }

  moveThumb(0);
  updateArrows(0);

  var $list = jQuery(".phy-blog-category-links__list", root);

  // Expose carousel semantics only while Slick is active; the same <ul> is a plain
  // static grid once it unslicks on desktop, so the attrs are removed on destroy.
  $list
    .on("init", function () {
      $list.attr("aria-roledescription", "carousel");
      $list.attr("aria-label", "Blog categories");
      updatePeekSide(0);
    })
    .on("destroy", function () {
      $list.removeAttr("aria-roledescription");
      $list.removeAttr("aria-label");
      $list.removeClass("phy-blog-category-links__list--peek-start");
    });

  $list
    .slick({
      mobileFirst: true,
      slidesToShow: slidesToShow,
      slidesToScroll: 1,
      infinite: false,
      arrows: false,
      dots: false,
      // Unslick at the blog desktop breakpoint (900px) so desktop is a static grid.
      responsive: [
        {
          breakpoint: 900,
          settings: "unslick",
        },
      ],
    })
    .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
      moveThumb(nextSlide);
      updateArrows(nextSlide);
      updatePeekSide(nextSlide);
    });

  // Custom prev/next controls drive Slick (guarded so they no-op once unslicked).
  function isSlick() {
    return $list.hasClass("slick-initialized");
  }

  if (prevBtn) {
    prevBtn.addEventListener("click", function () {
      if (isSlick()) {
        $list.slick("slickPrev");
      }
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener("click", function () {
      if (isSlick()) {
        $list.slick("slickNext");
      }
    });
  }
});
